import React, { Fragment } from 'react';
import Subtitle from '../ui/Subtitle';
import { Stack, Tabs, Tab } from '@mui/material';
import StatsGames from './stats/StatsGames';
import StatsPositions from './stats/StatsPositions';
import StatsDoubles from './stats/StatsDoubles';
import StatsLeagueTablePredictor from './stats/StatsLeagueTablePredictor';
import useStickyState from '../../utils/useStickyState';
import StatsSeats from './stats/StatsSeats';
import StatsSeasons from './stats/StatsSeasons';
import StatsStreaks from './stats/StatsStreaks';

const TabPanel=({children,value,index})=>{
    return(
        <Fragment>
            {value === index && children }
        </Fragment>
    )
}

const StatsPage = () => {
    const [value, setValue] = useStickyState(0,"statsPage",{sessionOnly:true});
    return(
        <Stack spacing="8px">
            <Subtitle text="Statto's Corner"/>
            <Tabs
                    value={value}
                    onChange={(event,newValue)=>setValue(newValue)}
                    TabIndicatorProps={{ sx: { display: 'none' } }}
                    sx={{
                        '& .MuiTabs-flexContainer': {
                            flexWrap: 'wrap'
                        },
                    }}
            >
                <Tab label="Seasons" />
                <Tab label="Games"/>
                <Tab label="Positions"/>
                <Tab label="Streaks"/>
                <Tab label="Doubles"/>
                <Tab label="Predictor"/>
                <Tab label="Seats" />
            </Tabs>
            <TabPanel value={value} index={0}>
                <StatsSeasons/>
            </TabPanel>
            <TabPanel value={value} index={1}>
                <StatsGames/>
            </TabPanel>
            <TabPanel value={value} index={2}>
                <StatsPositions/>
            </TabPanel>
            <TabPanel value={value} index={3}>
                <StatsStreaks/>
            </TabPanel>
            <TabPanel value={value} index={4}>
                <StatsDoubles/>
            </TabPanel>
            <TabPanel value={value} index={5}>
                <StatsLeagueTablePredictor/>
            </TabPanel>
            <TabPanel value={value} index={6}>
                <StatsSeats/>
            </TabPanel>
        </Stack>
    )
}

export default StatsPage;
